import {MYASSET_APIS} from '$constants/api-infos'
import {internalApi} from '$utils/api'

import type {TaskRequest, TaskResponse} from '@mydata/updater'

const {POST_UPDATER_ASYNC} = MYASSET_APIS

export async function requestUpdateAsync(taskRequestList: TaskRequest[]) {
    const {path, method} = POST_UPDATER_ASYNC
    const {data} = await internalApi<TaskResponse[]>(path, {method, data: taskRequestList})
    return data
}
